import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LegacySection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-124">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1536640712-4d4c36ff0e4e?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-luminosity" data-id="element-125"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-900/90 to-navy-900" data-id="element-126"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-127">
        <FadeIn direction="right" data-id="element-128">
          <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6" data-id="element-129">
            ¿Qué apellido le vas a dejar a{' '}
            <span className="italic text-gold-400" data-id="element-130">tus hijos?</span>
          </h2>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-131">
          <div className="border-l border-gold-500/30 pl-8 py-2" data-id="element-132">
            <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-133">
              Viniste aquí para darles un futuro, no para heredarles tu lucha.
              Si tu dinero se queda bajo el colchón, la inflación se lo está
              robando. Si no tienes activos, solo tienes facturas.
            </p>
            <p className="text-lg text-white font-medium" data-id="element-134">
              Convierte tu apellido en una marca de riqueza. De la limpieza de
              crédito a la bolsa de valores. El Código está aquí.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}